// @flow
import * as React from 'react';
import { JsonForms } from '@jsonforms/react';

import useParseMetadata from 'platform/settings/form/utils/useParseMetadata';
import { generateKeyFromId } from 'platform/settings/form/utils/parseMetadata';

type Props = {
    value: $FixMe,
    metadata: $FixMe,
    i18n: $FixMe,
    renderers: Array<$FixMe>
};

const JsonView = ({ i18n, metadata, renderers, value }: Props): React.Node => {
    const { schema, uiSchema } = useParseMetadata(metadata);

    const _i18n = React.useMemo(() => {
        return {
            locale: i18n.locale,
            translate: (id, defaultValue) => {
                if (!defaultValue) {
                    return;
                }
                const key = generateKeyFromId(id);
                return i18n.translate(key, defaultValue);
            }
        };
    }, [i18n]);

    return (
        <JsonForms
            schema={schema}
            uischema={uiSchema}
            data={value}
            renderers={renderers}
            i18n={_i18n}
        />
    );
};

export default JsonView;
